import LogsSection from '@/views/logs/LogsSection.vue';
import Logs from '@/views/logs/Logs.vue';

export default [
  {
    path: '/logs',
    component: LogsSection,
    meta: {
      breadcrumb: {
        linkName: 'logs.index',
        linkText: 'Logs',
      },
    },
    children: [
      {
        path: 'explorer',
        component: Logs,
        name: 'logs.index',
      },
    ],
  },
];
